import useMobxStores from 'hooks/useMobxStores';
import React from 'react';
import PremiumClassCard from 'components/Classes/PremiumClasses/Card';
import { PremiumSessionContentWithSchedule } from 'stores/PremiumSessionFilter/config';
import { withErrorBoundary } from 'react-error-boundary';
import { observer } from 'mobx-react';
import GenericViewError from 'components/Error/GenericViewError';
import { handleError } from 'services/ErrorService';

type Props = {
  paginatedEntries: PremiumSessionContentWithSchedule[];
};

const LegacyLiveSessionList = ({ paginatedEntries }: Props) => {
  const { classesStore } = useMobxStores();
  return (
    <div className="live-sessions__list">
      {paginatedEntries.map((entry) => {
        const { doc_id: docId } = entry;
        return (
          <PremiumClassCard
            key={docId}
            coloredBottom
            premiumClass={entry}
            enrollments={classesStore.getPremiumClassEnrollmentsForCourseSlug(
              entry.offering_slug,
            )}
          />
        );
      })}
    </div>
  );
};

export default withErrorBoundary(
  observer(LegacyLiveSessionList),
  GenericViewError,
  handleError,
);
